export const translate = (key: string): string => {
    return window.sv_resource.get(key);
}
